const firebaseConfig = {
    apiKey: "AIzaSyAFump0mkQdtxqpZ2_dYDSMqWprZBbPcuw",
    authDomain: "bikezone-a79ff.firebaseapp.com",
    projectId: "bikezone-a79ff",
    storageBucket: "bikezone-a79ff.firebasestorage.app",
    messagingSenderId: "1067547068909",
    appId: "1:1067547068909:web:e35126ded7eac7e9e87fe4"
  };

export default firebaseConfig